import { API_URL } from '../../../app-config/constants';
import ConnectCompanyRequest from '../../../types/ConnectCompanyRequest';
import CustomerDto from '../../../types/CustomerDto';
import CustomerWrapper from '../../../types/CustomerWrapper';
import { Estimate } from '../../../types/Estimate';
import FreshbooksCustomerDto from '../../../types/FreshbooksCustomerDto';
import { UpdateSubscriptionRequest } from '../../../types/UpdateSubscriptionRequest';
import { get, post, put } from '../request';

const CO_BASE_URL = `${API_URL}/billing`;

const wrap =
    (companyId: string) =>
    (customer?: CustomerDto): CustomerWrapper => {
        return {
            id: companyId,
            customer,
        };
    };

getCustomerForCompany.operation = 'READ';
export function getCustomerForCompany(companyId: string, cache?: boolean): Promise<CustomerWrapper> {
    return get<CustomerDto>(
        `${CO_BASE_URL}/${companyId}`,
        cache !== undefined ? { getData: { cache: String(cache) } } : {}
    ).then(wrap(companyId));
}

invalidate.operation = 'NO_OPERATION';
invalidate.invalidates = ['getCustomerForCompany'];
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function invalidate(companyId: string) {
    return Promise.resolve();
}

connectCompany.operation = 'COMMAND';
export function connectCompany(companyId: string, request: ConnectCompanyRequest): Promise<CustomerWrapper> {
    return post<CustomerDto>(`${CO_BASE_URL}/${companyId}/connect`, { postData: request }).then(wrap(companyId));
}

export function updateSubscriptionPreview(companyId: string, update: UpdateSubscriptionRequest) {
    return post<Estimate>(`${CO_BASE_URL}/${companyId}/update-subscription-preview`, { postData: update });
}

export function estimateNextRenewal(companyId: string) {
    return get<Estimate>(`${CO_BASE_URL}/${companyId}/estimate-next-renewal`);
}

updateSubscription.operation = 'COMMAND';
export function updateSubscription(companyId: string, update: UpdateSubscriptionRequest): Promise<CustomerWrapper> {
    return post<CustomerDto>(`${CO_BASE_URL}/${companyId}/update-subscription`, { postData: update }).then(
        wrap(companyId)
    );
}

switchPlanModel.operation = 'COMMAND';
export function switchPlanModel(companyId: string): Promise<CustomerWrapper> {
    return post<CustomerDto>(`${CO_BASE_URL}/${companyId}/switch-plan-model`).then(wrap(companyId));
}

export function getFreshbooksCustomerForCompany(companyId: string): Promise<FreshbooksCustomerDto> {
    return get(`${CO_BASE_URL}/${companyId}/freshbooks-customer`);
}

export function getCollectNowUrl(companyId: string) {
    return post<string>(`${CO_BASE_URL}/${companyId}/collect-now`);
}

// waiting on: https://github.com/ladda-js/ladda/pull/43
// updateFreshbooksDetails.operation = 'UPDATE';
// updateFreshbooksDetails.idFrom = (data: FreshbooksData) => data.companyId;
export function updateFreshbooksCustomer(freshbooksCustomerDto: FreshbooksCustomerDto): Promise<FreshbooksCustomerDto> {
    return put(`${CO_BASE_URL}/${freshbooksCustomerDto.companyId}/freshbooks-customer`, {
        postData: freshbooksCustomerDto,
    });
}
